import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Alert,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Popover,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import axios from "axios";
import PickemLeaderboardTable from "src/components/pickem-edit/PickemLeaderboardTable";
// ----------------------------------------------------------------------

export default function LeaderboardPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [leaderboard, setLeaderboard] = useState(null);
  const [pickemId, setPickemId] = useState(null);
  const [tournamentId, setTournamentId] = useState(null);
  const [leagueId, setLeagueId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [pickem, setPickem] = useState(null)
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [openSendEmail, setOpenSendEmail] = useState(false);
  const [sendEmailText, setSendEmailText] = useState({
    prize_text_en: "",
    prize_text_lv: "",
    prize_text_et: "",
    prize_text_ru: "",
    prize_text_sk: "",
  });

  useEffect(()=>{
      if(pickem && leaderboard.leaderboard){
        const answers_leaderboard= leaderboard.leaderboard.map((userLeaderboard)=>{
          const answers = userLeaderboard.selections.reduce(
            (accum, selection)=> {
              const question = pickem.questions.find((item)=>item.question_id===selection.question_id)
              if(question){
                if(question.is_tiebreak){
                  accum.custom_value = +question.tiebreak_score === +selection.custom_value
                }
                const option = question.options.find((item)=>item.option_id===selection.option_id)
                if(option){
                  if (!!option.is_correct) {
                    accum.correct++
                  }
                  if (!option.is_correct) {
                    accum.incorrect++
                  }
                }
              }
              return accum
            }, {correct: 0, incorrect: 0, custom_value:false})
          return {...userLeaderboard, answers}
        })
        setLeaderboard({...leaderboard, leaderboard:answers_leaderboard})
      }
  },[pickem])

  useEffect(() => {
    if (searchParams.has("pickem_id")) {
      let pickemId = searchParams.get("pickem_id");
      setPickemId(pickemId);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-leaderboard/${pickemId}`
        )
        .then(function (response) {
          setLeaderboard(response.data);
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${pickemId}`
          ).then(function (response) {
            setPickem(response.data.pickem)
            setLoading(false);
          });
          setLoading(false);
        });

    } else if (
      searchParams.has("league_id") &&
      searchParams.has("tournament_id")
    ) {
      let leagueId = searchParams.get("league_id");
      let tournamentId = searchParams.get("tournament_id");
      setTournamentId(tournamentId);
      setLeagueId(leagueId);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/league-tournament-leaderboard/${leagueId}?tournament_id=${tournamentId}`
        )
        .then(function (response) {
          setLeaderboard(response.data);
          setLoading(false);
        });
    }
  }, []);

  const handleForcePickemScoring = () => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${pickemId}/run-leaderboard-scoring`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleAddTrophy = (userId, trophy) => {
    setLoading(true);
    const params =
      pickemId !== null
        ? `pickem_id=${pickemId}`
        : `tournament_id=${tournamentId}`;
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/leaderboard/user/add-trophy?${params}`,
        { user_id: userId, trophy }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleRemoveTrophy = (userId) => {
    setLoading(true);
    const params =
      pickemId !== null
        ? `pickem_id=${pickemId}`
        : `tournament_id=${tournamentId}`;
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/leaderboard/user/remove-trophy?${params}`,
        { user_id: userId }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleForceTournamentsScoring = () => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${pickemId}/run-tournaments-leaderboard-scoring`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleDownloadCsv = () => {
    setLoading(true);
    axios({
      url: `${process.env.REACT_APP_API_BASE_URL}/admin/leaderboard/export-csv/${pickemId}`,
      method: 'GET',
      responseType: 'blob',
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const now = new Date();
      const dateTime = now.toISOString().slice(0, 16).replace('T', ' ');
      link.setAttribute('download', `leaderboard-pickem-${pickemId} ${dateTime}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setLoading(false);
    })
    .catch((error) => {
      console.error('Error during CSV download', error);
      setLoading(false);
    });
  };

  const handleOpenSendEmailDialog = () => {
    setSendEmailText({
      prize_text_en: "",
      prize_text_lv: "",
      prize_text_et: "",
      prize_text_ru: "",
      prize_text_sk: "",

      contestname_en: "",
      contestname_ru: "",
      contestname_lv: "",
      contestname_et: "",
      contestname_sk: "",
    });
    setOpenSendEmail(true);
  };

  const handleSendEmail = () => {
    setLoading(true);
    setOpenSendEmail(false);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/send-prize-notifications`,
        {
          ...sendEmailText,
          user_ids: checkedUsers,
          pickem_id: pickemId,
          league_id: leagueId,
          tournament_id: tournamentId,
        }
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const handleChangeEmailFields = (e) => {
    const { id, value } = e.target;

    setSendEmailText((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  return (
    <>
      <Helmet>
        <title>Leaderboard </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Leaderboard View
          </Typography>
        </Stack>
        {leagueId !==null &&
          tournamentId!==null &&
          checkedUsers.length > 0 && (
          <Card style={{ padding: 20 }}>
            <Box>
              <Typography variant="h5" component="div" sx={{ marginBottom: 2 }}>
                Message
              </Typography>
                <Button
                  variant="outlined"
                  startIcon={<Iconify icon="eva:paper-plane-outline" />}
                  onClick={() => handleOpenSendEmailDialog()}
                  sx={{ mr: 2 }}
                >
                  Send Prize Email
                </Button>
              </Box>
          </Card>
          )}
        {pickemId !== null ? (
          <Card style={{ padding: 20 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={5}
            >
              <Typography variant="h5" component="div" sx={{ marginBottom: 2 }}>
                Scoring
              </Typography>
              <Box>
                {checkedUsers.length > 0 && (
                  <Button
                    variant="outlined"
                    startIcon={<Iconify icon="eva:paper-plane-outline" />}
                    onClick={() => handleOpenSendEmailDialog()}
                    sx={{ mr: 2 }}
                  >
                    Send Prize Email
                  </Button>
                )}

                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:list-outline" />}
                  onClick={() => handleForceTournamentsScoring()}
                  sx={{ mr: 2 }}
                >
                  Update All Leaderboards
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:rewind-right-outline" />}
                  onClick={() => handleForcePickemScoring()}
                  sx={{ mr: 2 }}
                >
                  Score Daily
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:download-outline" />}
                  onClick={() => handleDownloadCsv()}
                >
                  Export Csv
                </Button>
              </Box>
            </Stack>

            {leaderboard !== null ? (
              <>
                <Alert sx={{ marginTop: 2 }} severity="info">
                  {`Pickem Scoring progress: ${leaderboard.completedScoringCount} / ${leaderboard.selectionsCount}`}
                </Alert>
                <Alert sx={{ marginTop: 2 }} severity="info">
                  {`Tournament Scoring progress: ${leaderboard.completedTournamentsScoringCount} / ${leaderboard.selectionsCount}`}
                </Alert>
              </>
            ) : null}
          </Card>
        ) : null}

        <Card>
          {leaderboard === null || loading && (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          )}
          { pickemId != null && (<PickemLeaderboardTable pickemId={pickemId} />)}
        </Card>
      </Container>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => handleAddTrophy(openId, "gold")}>
          <Iconify icon={"eva:star-outline"} sx={{ mr: 1 }} />
          Add Gold Trophy
        </MenuItem>

        <MenuItem onClick={() => handleAddTrophy(openId, "silver")}>
          <Iconify icon={"eva:star-outline"} sx={{ mr: 1 }} />
          Add Silver Trophy
        </MenuItem>
        <MenuItem onClick={() => handleRemoveTrophy(openId)}>
          <Iconify icon={"eva:close-outline"} sx={{ mr: 1 }} />
          Remove Trophy
        </MenuItem>
        {pickemId !== null ? (
          <MenuItem
            onClick={() =>
              navigate(
                `/dashboard/user-selections?pickem_id=${pickemId}&user_id=${openId}`
              )
            }
          >
            <Iconify icon={"eva:eye-outline"} sx={{ mr: 1 }} />
            User Selections
          </MenuItem>
        ) : null}
      </Popover>
      <Dialog
        open={openSendEmail}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Send Email</DialogTitle>
        <DialogContent>
          <TextField
            id="prize_text_en"
            label="Prize Text EN"
            fullWidth
            value={sendEmailText.prize_text_en}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="prize_text_lv"
            label="Prize Text LV"
            fullWidth
            value={sendEmailText.prize_text_lv}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="prize_text_ru"
            label="Prize Text RU"
            fullWidth
            value={sendEmailText.prize_text_ru}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="prize_text_et"
            label="Prize Text ET"
            fullWidth
            value={sendEmailText.prize_text_et}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="prize_text_sk"
            label="Prize Text SK"
            fullWidth
            value={sendEmailText.prize_text_sk}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_en"
            label="Contest Name EN"
            fullWidth
            value={sendEmailText.contestname_en}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_lv"
            label="Contest Name LV"
            fullWidth
            value={sendEmailText.contestname_lv}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_ru"
            label="Contest Name RU"
            fullWidth
            value={sendEmailText.contestname_ru}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_et"
            label="Contest Name ET"
            fullWidth
            value={sendEmailText.contestname_et}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
          <TextField
            id="contestname_sk"
            label="Contest Name SK"
            fullWidth
            value={sendEmailText.contestname_sk}
            variant="standard"
            onChange={handleChangeEmailFields}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSendEmail(false)}>Cancel</Button>
          <Button onClick={() => handleSendEmail()} autoFocus>
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
